import axios from 'axios';

/**
 * Get user profile from API
 * @param {Function} getAPIUrl - Function to build API URL (already includes baseUrl)
 * @param {Function} getAuthToken - Function to get auth token
 * @param {Function} getLoginPage - Function to redirect to login
 * @param {Function} callback - Optional callback function
 * @param {Function} setuserDetails - Optional function to set user details in context
 * @param {Function} isAdmin - Optional function to check if user is admin
 * @param {Function} sendPosthogInfo - Optional function to send PostHog info
 */
export function GetProfile(
  getAPIUrl,
  getAuthToken,
  getLoginPage,
  callback,
  setuserDetails,
  isAdmin,
  sendPosthogInfo
) {
  var config = {
    method: "get",
    url: getAPIUrl("/api/auth/profile/"),
    cache: false,
    headers: {
      Authorization: getAuthToken(),
    },
  };

  axios(config)
    .then(async function (res) {
      const tp = await res.data;
      if (tp.success) {
        var auth_dict = {
          eventGraphiaName: tp.name,
          eventGraphiaEmail: tp.email,
          eventGraphiaId: tp.id,
          eventGraphiaPhone: tp.phone_no,
          eventGraphiaCity: tp.user_city,
          eventGraphiaInitials: tp.name_initials,
          is_mobile_app: tp.is_mobile_app,
        };
        localStorage.setItem("auth_dict", JSON.stringify(auth_dict));

        // Update context with user details if setter is provided
        if (setuserDetails) {
          setuserDetails(auth_dict);
        }

        // Send PostHog info if not admin and function is provided
        if (!isAdmin || !isAdmin()) {
          if (sendPosthogInfo) {
            sendPosthogInfo({
              id: tp.id,
              phone_no: tp.phone_no,
              name: tp.name
            });
          }
        }

        if (callback) callback();
      }
    })
    .catch(function (tp) {
      if (getLoginPage) {
        getLoginPage();
      }
      console.log(tp.message);
    });
}

